{
    "en": {
        "translation": {
            "A link to edit registration": "A link to edit registration",
            "Ad content": "Ad content",
            "Add another entry": "Add another entry",
            "Advertisement Form Section": "Advertisement Form Section",
            "An error occured": "An error occured",
            "Api": "Api",
            "Boat for rent": "Boat for rent",
            "Boats for rent": "Boats for rent",
            "Browser": "Browser",
            "By alt. way": "By alt. way",
            "By creating an account you will be able to manage your registration data and subscribe to regatta events": "By creating an account you will be able to manage your registration data and subscribe to regatta events",
            "By red flag": "By red flag",
            "Calculation method": "Calculation method",
            "Champ.": "Champ.",
            "Championship page": "Championship page",
            "Chmapionship title": "Chmapionship title",
            "Choose": "Choose",
            "Choose the group you want to participate in": "Choose the group you want to participate in",
            "Coef.": "Coef.",
            "Confirmation needed": "Confirmation needed",
            "Contact data": "Contact data",
            "Contacts": "Contacts",
            "Cookies are used. OK?": "Cookies are used. OK?",
            "Copy link": "Copy link",
            "Create and manage regattas": "Create and manage regattas",
            "Date published": "Date published",
            "Device": "Device",
            "Device data": "Device data",
            "Do you really want to resign from regatta?": "Do you really want to resign from regatta?",
            "Do you really want to sign out?": "Do you really want to sign out?",
            "Documents": "Documents",
            "Edit registration to regatta": "Edit registration to regatta",
            "Error!": "Error!",
            "Eur": "Eur",
            "Event": "Event",
            "Filled entry form": "Filled entry form",
            "If that does not help please ": "If that does not help please ",
            "Invalidate": "Invalidate",
            "Ip": "Ip",
            "Item loading": "Item loading",
            "Less fields": "Less fields",
            "Loading...": "Loading...",
            "Manage": "Manage",
            "Max": "Max",
            "Member ID.": "Member ID.",
            "Messages": "Messages",
            "More fields": "More fields",
            "My data": "My data",
            "My regattas": "My regattas",
            "No protests yet": "No protests yet",
            "No published documents yet": "No published documents yet",
            "No published results yet": "No published results yet",
            "No regatta entries yet": "No regatta entries yet",
            "No regattas yet": "No regattas yet",
            "No related to this email regatta entry crewmembers or coaches were found.": "No related to this email regatta entry crewmembers or coaches were found.",
            "No.": "No.",
            "Not ready yet": "Not ready yet",
            "Ok": "Ok",
            "Open menu": "Open menu",
            "Organizer": "Organizer",
            "Other data": "Other data",
            "Part of championships": "Part of championships",
            "Pdf": "Pdf",
            "Place": "Place",
            "Preliminary": "Preliminary",
            "Previous crewmembers": "Previous crewmembers",
            "Previous year championship": "Previous year championship",
            "Previous year regatta": "Previous year regatta",
            "Profile page": "Profile page",
            "Protest": "Protest",
            "Protests": "Protests",
            "Public api": "Public api",
            "Race information": "Race information",
            "Races": "Races",
            "Rating": "Rating",
            "Refresh page": "Refresh page",
            "Regatta date": "Regatta date",
            "Regatta location": "Regatta location",
            "Regatta title": "Regatta title",
            "Regattas entries": "Regattas entries",
            "Region championsips page": "Region championsips page",
            "Region regattas page": "Region regattas page",
            "Registration date": "Registration date",
            "Registration has ended": "Registration has ended",
            "Registration is disabled": "Registration is disabled",
            "Registration will start soon": "Registration will start soon",
            "Results": "Results",
            "Rule": "Rule",
            "Schedule": "Schedule",
            "Search": "Search",
            "Search season regattas": "Search season regattas",
            "Season championships": "Season championships",
            "Season regattas": "Season regattas",
            "Select region": "Select region",
            "Session": "Session",
            "Share": "Share",
            "Show all": "Show all",
            "Show all messages": "Show all messages",
            "Show ended regattas": "Show ended regattas",
            "Show full data": "Show full data",
            "Show full list": "Show full list",
            "Show full schedule": "Show full schedule",
            "Show less": "Show less",
            "Show more": "Show more",
            "Show older notifications": "Show older notifications",
            "Show older regattas": "Show older regattas",
            "Sign in / Sign up": "Sign in / Sign up",
            "Source file": "Source file",
            "Sponsor": "Sponsor",
            "Start": "Start",
            "Submit": "Submit",
            "Submit data": "Submit data",
            "Submit protest": "Submit protest",
            "Success!": "Success!",
            "The group has reached the entries limit": "The group has reached the entries limit",
            "Tracker": "Tracker",
            "Update data": "Update data",
            "Use": "Use",
            "View document": "View document",
            "Will be defined": "Will be defined",
            "Your account email": "Your account email",
            "by": "by",
            "protest time limit": "protest time limit"
        }
    }
}
